import React, { useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import { useState } from "react";
import { Link } from "react-router-dom";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";


const ViewModal = ({ id, data }) => {
    const { isViewModalOpen, closeModal } = useContext(SidebarContext);

    var result = data.find((item) => item.id === id);
    const [previewImage, setPreviewImage] = useState(null);

    const BaseImg = process.env.REACT_APP_API_IMAGE_URL;

    const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }
    
    `;
    const handleDownload = async () => {
        try {
            const fileUrl = `${BaseImg}${result.partnership_deed_path}`;
            const response = await fetch(fileUrl);
            if (!response.ok) throw new Error("Network response was not ok");
            const blob = await response.blob();
            const fileName = "channel partner";
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Download failed:", error);
            alert("File download failed");
        }
    };



    return (
        <>
            <style>{style}</style>

            <Modal
                className="relative bg-white dark:bg-gray-700 dark:text-white w-1/2 rounded-lg"
                isOpen={isViewModalOpen}
                onClose={() => {
                    closeModal();
                }}
            >
                <ModalBody className="custom-modal">
                    <div>

                        <CommonCloseBtn
                        onClose={closeModal}
                        />
                        <h2 className="text-center font-bold text-lg">Channel Partner details</h2>

                        {/* Tab Content */}
                        <div
                            className="p-6 max-h-96 overflow-y-scroll"
                            style={{ maxHeight: "400px", scrollbarWidth: "thin" }}
                        >
                            <dl className="border rounded-lg border-gray-300 dark:border-gray-500 text-sm dark:text-white">
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Company Name
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 ">
                                        {result?.company_name || '-'}
                                    </dd>
                                </div>

                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Partner Name
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.contact_person_name || '-'}
                                    </dd>
                                </div>
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Contact Number
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.phone_number || '-'}
                                    </dd>
                                </div>
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Partner Email
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.email_id || '-'}
                                    </dd>
                                </div>
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Branch Locations
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {Array.isArray(result?.branch_location_names)
                                            ? result.branch_location_names.join(", ")
                                            : "-"}
                                    </dd>
                                </div>
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        City
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.partner_city_name || '-'}
                                    </dd>
                                </div>
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        State
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.partner_state_name || '-'}
                                    </dd>
                                </div>

                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Zipcode
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.partner_zipcode || '-'}
                                    </dd>
                                </div>
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        No. of Employees
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.no_of_employees + " Employees" || '-'}
                                    </dd>
                                </div>

                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Ownership type
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.ownership_type || '-'}
                                    </dd>
                                </div>


                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Number of Branches
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.no_of_branches + " Branches" || '-'}
                                    </dd>
                                </div>
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Years of Experience
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.years_of_experience + " Year experience" || '-'}
                                    </dd>
                                </div>
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Date
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.created_at
                                            ? new Date(result.created_at).toLocaleDateString("en-GB")
                                            : "-"}
                                    </dd>
                                </div>
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Having Branch
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.having_branch || '-'}
                                    </dd>
                                </div>
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Sell Holiday Packages
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.sell_holiday_package || '-'}
                                    </dd>
                                </div>


                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Channel Partner  Reason
                                    </dt>
                                    <dd
                                        className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20"
                                        style={{
                                            wordWrap: "break-word",
                                            overflowWrap: "break-word",
                                            whiteSpace: "normal",
                                        }}
                                    >
                                        {result?.partner_reason || '-'}
                                    </dd>
                                </div>

                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        PAN Number
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.pan_number || '-'}
                                    </dd>
                                </div>
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4" style={{ alignItems: "center" }}>
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        PAN Image
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.pan_card_path ? (
                                            <img
                                                src={BaseImg + result?.pan_card_path}
                                                alt="PAN Card"
                                                onClick={() => setPreviewImage(BaseImg + result?.pan_card_path)}
                                                className="h-32 w-auto cursor-pointer rounded border object-contain hover:scale-105 transition"
                                            />
                                        ) : (
                                            <span>-</span>
                                        )}
                                    </dd>
                                </div>


                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4" >
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        GST Number
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.gst_number || '-'}
                                    </dd>
                                </div>
                                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4" style={{ alignItems: "center" }}>
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        GST Image
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {BaseImg + result?.gst_card_path ? (
                                            <img
                                                src={BaseImg + result?.gst_card_path}
                                                alt="GST Certificate"
                                                onClick={() => setPreviewImage(BaseImg + result?.gst_card_path)}
                                                className="h-32 w-auto cursor-pointer rounded border object-contain hover:scale-105 transition"
                                            />
                                        ) : (
                                            <span>-</span>
                                        )}
                                    </dd>
                                </div>
                                <div
                                    className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4"
                                    style={{ alignItems: "center" }}
                                >
                                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                                        Partner Deed
                                    </dt>
                                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                                        {result?.partnership_deed_path ? (
                                            <>
                                                <a
                                                    href={`${BaseImg}${result.partnership_deed_path}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-600 underline"
                                                >
                                                    View Partner Deed
                                                </a>
                                                <button
                                                    onClick={handleDownload}
                                                    className="ml-4 text-green-600 underline"
                                                >
                                                    Download Partner Deed
                                                </button>

                                            </>

                                        ) : (
                                            <span>-</span>
                                        )}
                                    </dd>
                                </div>

                                {previewImage && (
                                    <div
                                        className="fixed inset-0 z-50 flex items-center justify-center bg-black/70"
                                        onClick={() => setPreviewImage(null)}
                                    >
                                        <div className="relative max-h-[90vh] p-4" style={{ maxWidth: "25rem" }}>
                                            <button
                                                onClick={() => setPreviewImage(null)}
                                                className="absolute -top-2 -right-2 rounded-full bg-black px-2 py-1 text-white shadow"
                                                style={{right:" 15px"}}
                                            >
                                                ✕
                                            </button>
                                            <img
                                                src={previewImage}
                                                alt="Preview"
                                                className="max-h-[15vh] w-auto rounded bg-white" style={{padding:"5px 8px"}}
                                            />

                                        </div>
                                    </div>
                                )}



                            </dl>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default React.memo(ViewModal);
